import React, { ReactNode } from 'react';

import { AppRoutes } from 'app/static/routes/routes-enum';
import { QUIPUSWAP } from 'app/utils/defaults';
import { ReactComponent as Overview } from 'app/components/svg/Overview.svg';
import { ReactComponent as Pairs } from 'app/components/svg/Pairs.svg';
import { ReactComponent as Tokens } from 'app/components/svg/Tokens.svg';
import { ReactComponent as Saved } from 'app/components/svg/Saved.svg';

import { ReactComponent as Docs } from 'app/components/svg/Footer/Docs.svg';
import { ReactComponent as QuipuSwap } from 'app/components/svg/Footer/QuipuSwap.svg';
import { ReactComponent as Discord } from 'app/components/svg/Footer/Discord.svg';
import { ReactComponent as Reddit } from 'app/components/svg/Footer/Reddit.svg';
import { ReactComponent as Telegram } from 'app/components/svg/Footer/Telegram.svg';
import { ReactComponent as Twitter } from 'app/components/svg/Footer/Twitter.svg';

type MenuTypes = {
  id: number
  item: string
  to: AppRoutes
  Icon: React.FC
};

type FooterListType = {
  id: number
  Icon?: ReactNode
  href: string
  item: string
};

export const menuList = [
  {
    id: 1,
    item: 'Overview',
    to: AppRoutes.OVERVIEW,
    Icon: Overview,
  },
  {
    id: 2,
    item: 'Tokens',
    to: AppRoutes.TOKENS,
    Icon: Tokens,
  },
  {
    id: 3,
    item: 'Pairs',
    to: AppRoutes.PAIRS,
    Icon: Pairs,
  },
  {
    id: 6,
    item: 'Saved',
    to: AppRoutes.SAVED,
    Icon: Saved,
  },
] as MenuTypes[];

export const footerList = [
  {
    id: 1,
    item: 'QuipuSwap.com',
    href: QUIPUSWAP,
    Icon: <QuipuSwap />,
  },
  {
    id: 2,
    item: 'Docs',
    href: 'https://docs.quipuswap.com',
    Icon: <Docs />,
  },
  {
    id: 3,
    item: 'Twitter',
    href: 'https://twitter.com/madfishofficial',
    Icon: <Twitter />,
  },
  {
    id: 4,
    item: 'Telegram',
    href: 'https://t.me/MadFishCommunity',
    Icon: <Telegram />,
  },
  {
    id: 5,
    item: 'Discord',
    href: 'https://discord.com/invite/qFRZ8kVzkv',
    Icon: <Discord />,
  },
  {
    id: 6,
    item: 'Reddit',
    href: 'https://www.reddit.com/r/MadFishCommunity/',
    Icon: <Reddit />,
  },
] as FooterListType[];
